export default __webpack_public_path__ + "static/media/17655483781571183080.11f7e69a.svg";